import dayjs from "dayjs"

const stageCheck = (status, type) => {
    const registrationStatus = status?.find((e) => e.shortcut === 'registration')?.current_status
    const reviewStart = status?.find((e) => e.shortcut === 'judge-stage-1')?.start
    const reviewEnd = status?.find((e) => e.shortcut === 'judge-stage-3')?.end
    const shortlist = status?.find((e) => e.shortcut === 'shortlist')?.start
    const certificateApplicationStart = status?.find((e) => e.shortcut === 'certificate-application')?.start

    switch (type) {
        case 'registration-ongoing': 
            return registrationStatus === 'ongoing'

        case 'registration-end':
            return registrationStatus === 'done'

        case 'review-ongoing':
            return dayjs() >= dayjs(reviewStart) && dayjs() < dayjs(reviewEnd)

        case 'shortlist-end':
            return dayjs() >= dayjs(shortlist)

        case 'certificate-application-start':
            return dayjs() >= dayjs(certificateApplicationStart)

        default:
            return null
    }
}

export default stageCheck